export enum ProductInterestFormType {
  Standard = 'Standard',
  Villa = 'Villa',
}
